import React, {Component} from 'react';
import {Row, Col} from 'react-bootstrap';

//CSS
import '../../LandingSubcomponents/Servicios.css';


class Stock extends Component {
    render() {

        return (
            <Row className="monitoreo-digital">
                <Col md={6} xsHidden smHidden className="stock-seccion-izquierda">

                </Col>
                <Col md={6} sm={12} xs={12} className="monitoreo-seccion-derecha">
                    <Row>
                        <Col md={7} sm={12} xs={12} className="monitoreo-descripcion wow animated bounceInRight"
                             data-wow-duration="1s">
                            <h3>
                                Stock permanente de productos
                            </h3>
                            <h4>
                                Con el objetivo de suplir a cada uno de nuestros clientes que confían en nosotros día a
                                día contamos con un elevado de stock de las marcas mas reconocidas e en el mercado.
                            </h4>
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    }
}


export default Stock;


// WEBPACK FOOTER //
// ./src/pages/LandingPage/LandingSubcomponents/Servicios/Stock.js